import React from "react";

const FileInputsUploader = ({ fileInputs, setFileInputs }) => {
  const handleFileChange = (index, file) => {
    const updated = [...fileInputs];
    updated[index].file = file;
    setFileInputs(updated);
  };

  const addFileInput = () => {
    setFileInputs(prev => [...prev, { id: Date.now(), file: null }]);
  };

  const removeFileInput = (index) => {
    setFileInputs(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="w-full mt-6 space-y-4">
      <label className="font-bold text-black">Adjuntar archivos</label>
      {fileInputs.map((input, index) => (
        <div key={input.id} className="flex items-center space-x-4">
          <input
            type="file"
            accept=".pdf"
            onChange={(e) => handleFileChange(index, e.target.files[0])}
            className="w-full border-2 border-black p-2 rounded-lg"
          />
          <button
            type="button"
            onClick={() => removeFileInput(index)}
            className="text-red-600 hover:text-red-800"
          >
            Quitar
          </button>
        </div>
      ))}

      <button
        type="button"
        onClick={addFileInput}
        className="mt-2 text-blue-600 hover:text-blue-800"
      >
        + Agregar otro archivo
      </button>
    </div>
  );
};

export default FileInputsUploader;